import { TextField, Typography, Box, useMediaQuery, Button } from "@mui/material";
import { ButtonA, ModalA } from "@src/ruix";
import { useState } from "react";
import { apiServiceV2 } from "@src/api";
import { useRouter } from "next/router";
import { useSetRecoilState } from "recoil";
import { globalSnackbarState } from "@src/state";
import { validateEmail } from "@src/utils/sign";

interface MarketingMenuBoardModalProps {
	open: boolean;
	onClose: () => void;
}

export const MarketingMenuBoardModal = (props: MarketingMenuBoardModalProps) => {
	const { open, onClose } = props;
	const isMobile = useMediaQuery("(max-width: 600px)");
	const router = useRouter();
	const setSnackbarState = useSetRecoilState(globalSnackbarState);
	
	const [formData, setFormData] = useState({
		name: "",
		companyName: "",
		email: "",
	});

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async () => {
		if (!formData.name || !formData.companyName || !formData.email) {
			setSnackbarState("모든 항목을 입력해주세요.");
			return;
		}

		if (!validateEmail(formData.email)) {
			setSnackbarState("올바른 이메일 형식을 입력해주세요.");
			return;
		}

		try {
			await apiServiceV2.post("/utils/click-menu-board-unauth", formData);
			window.open("https://shrouded-meal-521.notion.site/2aff8567bbfa8029809bc906e4277307?v=2aff8567bbfa80218222000cad0af51c", "_blank");
			onClose();
		} catch (error) {
			console.error(error);
			setSnackbarState("제출 중 오류가 발생했습니다.");
		}
	};

	const onClickLogin = () => {
		router.push("/signin?type=client");
		onClose();
	};

	return (
		<ModalA isOpen={open} onClose={onClose} maxWidth="450px" bgColor="white">
			<Box sx={{ p: isMobile ? 2 : 4, textAlign: 'center' }}>
				<Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
					원포인트 마케팅 메뉴판
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
					성함, 고객사명, 이메일 주소를 입력하시면<br />
					마케팅 메뉴판 링크로 즉시 연결됩니다.
				</Typography>
				
				<Box sx={{ mb: 3, p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
					<Typography variant="body2">
						이미 회원이신가요?
					</Typography>
					<Typography variant="body2" sx={{ mb: 1 }}>
						로그인 후 메뉴판 확인하기 버튼을 클릭해주세요.
					</Typography>
					<Button 
						variant="outlined" 
						size="small" 
						onClick={onClickLogin}
						sx={{ fontWeight: 'bold' }}
					>
						로그인하기
					</Button>
				</Box>

				<TextField
					fullWidth
					label="성함"
					name="name"
					variant="outlined"
					value={formData.name}
					onChange={handleChange}
					sx={{ mb: 2 }}
				/>
				<TextField
					fullWidth
					label="고객사명"
					name="companyName"
					variant="outlined"
					value={formData.companyName}
					onChange={handleChange}
					sx={{ mb: 2 }}
				/>
				<TextField
					fullWidth
					label="이메일 주소"
					name="email"
					variant="outlined"
					value={formData.email}
					onChange={handleChange}
					sx={{ mb: 3 }}
				/>
				<ButtonA
					fullWidth
					buttonClass="primary"
					size="large"
					sx={{ py: 1.5, fontSize: '18px', fontWeight: 'bold' }}
					onClick={handleSubmit}
				>
					메뉴판 확인하기
				</ButtonA>
			</Box>
		</ModalA>
	);
};

